// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"28ad2344","885":"23a1d1cc"}[chunkId] + ".chunk.js";
};